import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort_descending",
  "use": "sort_descending-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"sort_descending\"><path d=\"M13.03 11.53c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-2.22 2.22V3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v9.69l-2.22-2.22a.754.754 0 0 0-1.06 0c-.15.15-.22.34-.22.53s.07.38.22.53L9 15.56z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol